
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
// import SpRelationDetails from "../../../../../components/global/Sidepanels/SpRelationDetails/SpRelationDetails";
// import SpInvoiceDetails from "../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails";
import { WarehouseInvoiceCard } from "../../../../../components/global/cards/financial/InvoiceCard";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { formatPrice } from "../../../../../utils/helpers";
import { getShipmentStatusLabeldata } from "../../../../../utils/labelColorText";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { SHIPMENTS_FILTER_KEYS } from "../../../../../components/global/DataGrid/Filter";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import { useGetRelationsSelectQuery } from "../../../../../newapi/global/relation/relationSlice";
import { showToastMessage } from "../../../../../utils/toasts";
import { useGetShipmentsQuery } from "../../../../../newapi/order/shipmentsSlice";
import { useExportShipmentsMutation } from "../../../../../newapi/order/ordersSlice";
import { general_states } from "../../../../../utils/staticEnums";
import MDynamicValues from "../../../../../components/global/Modals/MDynamicValues";
import { useGetShippersSelectQuery } from "../../../../../newapi/shipper/shipperSlice";
import SHQuickAction from "../../../../../components/theme/Modal/SHQuickAction";
import MLoader from "../../../../../components/global/Modals/MLoader";
import { getTrackingLink } from "../../../../../utils/shipping";

const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));
const SpReturnDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));
const SpShipmentDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpShipmentDetails/SpShipmentDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <ButtonGroup version={2}>
            <Shbutton
                onClick={() => props.setModalOpen(true)}
                className={"group-btn"}
                // onClick={props.action}
                color={"primaryGrey"}
                variant="contained"
                endIcon={<DownloadOutlinedIcon/>}
            >
                {t('export')}
            </Shbutton>
            {/* {props.hasModifyPrivilege && (
            )} */}
        </ButtonGroup>
    )
}

const OutboundShipments = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    const [returnIsExtended, setReturnIsExtended] = useState(false);
    const [returnSpLoading, setReturnSpLoading] = useState();

    const { data: relationData, relationIsLoading } = useGetRelationsSelectQuery();
    const { data: shipperData, shippersIsLoading } = useGetShippersSelectQuery();

    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    const gridOptions = {
        export:true,
        disableCustomActionsOnPhone: true,
        isSidepanel: true,
        filter: [
            SHIPMENTS_FILTER_KEYS.SHIPPER,
            SHIPMENTS_FILTER_KEYS.SHIPPER_PROFILE,
            SHIPMENTS_FILTER_KEYS.TYPE,
            SHIPMENTS_FILTER_KEYS.SHIPMENT_STATUS,
            SHIPMENTS_FILTER_KEYS.COUNTRY,
            ...(isFulfilment ? [SHIPMENTS_FILTER_KEYS.RELATION] : []),
        ],
    };
    
    const ref = useRef();
    const [config, setConfig] = useState();

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MANAGE])
    );

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    // The totals panel lives above the tab view, in the parent, and belongs to this tab only.
    // Report that this tab is open so it shows, and that it closed so it goes away again.
    useEffect(() => {
        props.onActiveChange?.(true);

        return () => props.onActiveChange?.(false);
    },[]);

    const [exportShipmentsModalOpen, setExportShipmentsModalOpen] = useState(false);
    const exportShipmentsModal = {
        open: exportShipmentsModalOpen,
        setOpen: setExportShipmentsModalOpen
    }

    const [loaderModalOpen, setLoaderModalOpen] = useState(false);
    const loaderModal = {
        open: loaderModalOpen,
        setOpen: setLoaderModalOpen,
    };
    
    const [exportShipments, {isLoading: isShipmentsExporting}] = useExportShipmentsMutation();
    const handleExportShipments = async (values) => {
        try {
            if(isShipmentsExporting) return;

            // Add state to values
            values.state = general_states.SHIPPED;

            if (!values.dateFrom || !/^\d{4}-\d{2}-\d{2}$/.test(values.dateFrom)) {
                showToastMessage("error", t("invalid_startdate"));
                return;
            }

            if (!values.dateTo || !/^\d{4}-\d{2}-\d{2}$/.test(values.dateTo)) {
                showToastMessage("error", t("invalid_enddate"));
                return;
            }

            // Validate date range does not exceed 45 days
            const startDateCheck = new Date(values.dateFrom);
            const endDateCheck = new Date(values.dateTo);
            const daysDiff = Math.ceil((endDateCheck - startDateCheck) / (1000 * 60 * 60 * 24));

            if (daysDiff > 45) {
                showToastMessage("error", t("date_range_max_45_days"));
                return;
            }

            loaderModal.setOpen(true);

            exportShipments(values).unwrap()
            .then(res => {
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer');
                if (newWindow) {
                    setTimeout(() => {
                        window.URL.revokeObjectURL(res.data);
                    }, 500);
                } else {
                    window.URL.revokeObjectURL(res.data);
                }
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                loaderModal.setOpen(false);
            });
            // Download is handled automatically in the mutation
        } catch (error) {
            console.error("Export failed", error);
        }
    }

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params?.row?.order) return;
    
        const newOrderId = parseInt(params.row.order.id);
        // Only update state if the productId has actually changed
        if (orderIdRef.current !== newOrderId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(orderId);
    
    const getReturnDetails = (params) => {
        if (!params?.row?.return) return;
    
        const newReturnId = parseInt(params.row.return.id);
        // Only update state if the productId has actually changed
        if (returnIdRef.current !== newReturnId) {
            if(!spLoading) {
                setReturnSpLoading(true);
            }
            setReturnId(newReturnId);
            returnIdRef.current = newReturnId; // Update the ref to the new value
        }
        setReturnIsExtended(true);
    };

    const [shipmentId, setShipmentId] = useState();
    const shipmentIdRef = useRef(shipmentId);
    const [shipmentIsExtended, setShipmentIsExtended] = useState(false);
    const [shipmentSpLoading, setShipmentSpLoading] = useState();

    const getShipmentDetails = (params) => {
        if (!params?.row?.id || params.row.skeleton) return;

        const newShipmentId = parseInt(params.row.id);
        // Only update state if the shipmentId has actually changed
        if (shipmentIdRef.current !== newShipmentId) {
            if (!shipmentSpLoading) {
                setShipmentSpLoading(true);
            }
            setShipmentId(newShipmentId);
            shipmentIdRef.current = newShipmentId; // Update the ref to the new value
        }
        setShipmentIsExtended(true);
    };

    const columns = [
        {
            field: "trackingNumber",
            headerName: t("tracking_number"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const trackingUrl = getTrackingLink(params.row);

                return (
                <Box sx={{height:1,display:"flex",flexDirection:"column",justifyContent:"center"}} onClick={(event) => {event.stopPropagation(); window.open(trackingUrl, "_blank")}}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.trackingNumber}</Text>
                </Box>);
            }
        },
        {field: "type", headerName: t("type"),flex:1, sortable: false,
            renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            const handleClick = (event) => {
                let type = "";
                if (params.row.order && !params.row.return) {
                    type = "order";
                } else if (params.row.return) {
                    type = "return";
                }

                event.stopPropagation(); // Prevent click from propagating to the row
                if (type === "order") {
                    getOrderDetails(params);
                } else if (type === "return") {
                    getReturnDetails(params);
                }
            };

            let relationName = "";
            let description = "";
            if (params.row.order && !params.row.return) {
                description = `${t("order")} - ${params.row.order.barcode}`;
                relationName = params.row.order.relation;
            } else if (params.row.return) {
                description = `${t("return")} - ${params.row.return.reference}`;
                relationName = params.row.return.relation;
            } else {
                // A loose shipment opens through the row click, so its type is plain text
                return t("individual_shipment");
            }

            return (
                <Box sx={{height:1,display:"flex",flexDirection:"column",justifyContent:"center"}} onClick={handleClick}>
                    <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{description}</Text>
                    {relationName && relationName.length > 0 && isFulfilment && (
                        <Text light color={colors.grey[500]}>{relationName}</Text>
                    )}
                </Box>
            );
        }},
        {field: "name", headerName: t("name"),flex:1, sortable: false,
            renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }

            let name = "";
            if (params.row.order) {
                name = params.row.order.deliveryName;
            } else if (params.row.return) {
                name = params.row.return.name;
            } else {
                name = params.row.name;
            }

            return name;
        }},
        {
            field: "address",
            headerName: t("address"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return `${params.row.street} ${params.row.house_nr}${params.row.house_nr_extra}`;
            }
        },
        {
            field: "city",
            headerName: t("city"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.city;
            }
        },
        {
            field: "postal",
            headerName: t("postal"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.postal;
            }
        },
        {
            field: "country",
            headerName: t("country"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return params.row.country?.toUpperCase();
            }
        },
        {
            field: "shipper",
            headerName: t("shipper"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return `${params.row.shipper?.name} - ${params.row.shipperProfile?.name}`;
            }
        },
        {
            field: "shipmentStatus",
            headerName: t("shipment_status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                if (!params.row.shipmentStatus) {
                    return "";
                }

                const stateData = getShipmentStatusLabeldata(params.row.shipmentStatus, theme);
                let labelcolor = stateData.labelcolor;
                let labeltext = stateData.labeltext;

                // If there are shipper events, wrap the label with SHQuickAction
                if (params.row.shipperEvents && params.row.shipperEvents.length > 0) {
                    return (
                        <SHQuickAction
                            maxWidth={700}
                            component={
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        pt: 2,
                                        px: 2,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: "relative",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                        }}
                                    >
                                        <Text
                                            bold
                                            sx={{ width: "140px", flexShrink: 0 }}
                                        >
                                            {t("date")}
                                        </Text>
                                        <Text
                                            bold
                                            sx={{ width: "140px", flexShrink: 0 }}
                                        >
                                            {t("type")}
                                        </Text>
                                        <Text
                                            bold
                                            sx={{ minWidth: "350px", flexShrink: 0 }}
                                        >
                                            {t("status")}
                                        </Text>
                                    </Box>

                                    {params.row.shipperEvents.map((event, index) => (
                                        <Box
                                            key={index + "event"}
                                            sx={{
                                                position: "relative",
                                                minHeight: 40,
                                                py: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                            }}
                                        >
                                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                                {event.timeStamp ? new Date(event.timeStamp).toLocaleString(i18n.language) : "-"}
                                            </Text>
                                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                                {event.type}
                                            </Text>
                                            <Text sx={{ minWidth: "350px", flexShrink: 0 }}>
                                                {event.status}
                                            </Text>
                                        </Box>
                                    ))}
                                </Box>
                            }
                        >
                            {({anchorEl, onMouseEnter, onMouseLeave, onTouchStart}) => (
                                <Box
                                    aria-owns={anchorEl ? "simple-popover" : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={onMouseEnter}
                                    onMouseLeave={onMouseLeave}
                                    onTouchStart={onTouchStart}
                                    sx={{
                                        display: "inline-flex",
                                    }}
                                >
                                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                                        {t(labeltext)}
                                    </ShLabel>
                                </Box>
                            )}
                        </SHQuickAction>
                    );
                }

                // No events, just show the label
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                );
              }
        },
        {
            field: "shipmentDate", 
            headerName: t("shipment_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = params.row.shipmentDate && params.row.shipmentDate !== null ? new Date(params.row.shipmentDate) : undefined;
              
                return (
                    <Text>
                        {date ? date.toLocaleDateString(i18n.language) : "-"}
                    </Text>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                // WarehouseInvoiceCard
                // return (
                //     // <WarehouseInvoiceCard
                //     //     onClick={() => getInvoice(params)}
                //     //     skeleton={params.row.skeleton}
                //     //     {...params.row}
                //     // />
                //     // <ShTextSkeleton/>
                // )
            }
        },
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetShipmentsQuery}
                config={config}
                gridActions={<GridActions setModalOpen={setExportShipmentsModalOpen}></GridActions>} 
                title={t('all')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[10].field,type:"DESC"}}
                columns={columns}
                rows={data}
                onRowClick={getShipmentDetails}
                >
            </ShDataGrid2>

            <MDynamicValues
                open={exportShipmentsModal.open}
                handleClose={() => exportShipmentsModal.setOpen(false)}
                title={t("export_shipments")}
                labelWidth={168}
                fields={[
                    { name: "relationId", label: t("relation"), type: "list", options: relationData, search: true },
                    { name: "shipperId", label: t("shipper"), type: "list", options: shipperData },
                    { name: "dateFrom", label: t("date_from"), type: "date", required: true },
                    { name: "dateTo", label: t("date_to"), type: "date", required: true },
                    { name: "includeProducts", label: t("export_products"), type: "switch", 
                        defaultValue: false, explainerTitle: t("export_products"), explainerSubTitle: t("shipments_export_products_text") }
                ]}
                onConfirm={(values) => handleExportShipments(values)}
            />

            <MLoader
                open={loaderModal.open}
                message={t("preparing_export")}></MLoader>

            {spLoading && 
                <SpOrderDetails
                    orderId={orderId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }
            {returnSpLoading && 
                <SpReturnDetails
                    returnId={returnId}
                    isExtended={returnIsExtended}
                    setIsExtended={setReturnIsExtended}
                    // data={pickingJobData}
                />
            }

            {shipmentSpLoading &&
                <SpShipmentDetails
                    shipmentId={shipmentId}
                    isExtended={shipmentIsExtended}
                    setIsExtended={setShipmentIsExtended}
                />
            }
        </Box>
    );
}

export default OutboundShipments;